import { render, staticRenderFns } from "./ClientEventPopUp.vue?vue&type=template&id=0461a195&scoped=true&"
import script from "./ClientEventPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientEventPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientEventPopUp.vue?vue&type=style&index=0&id=0461a195&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461a195",
  null
  
)

export default component.exports